import React from 'react';
import { ReadyState } from 'react-use-websocket';
import { SendJsonMessage } from 'react-use-websocket/dist/lib/types';
import { SessionWebhookResponse } from './types';

interface WebsocketApiConnectionContextProps {
  lastJsonMessage: SessionWebhookResponse | null;
  sendJsonMessage: SendJsonMessage;
  readyState: ReadyState;
}

export const WebsocketApiConnectionContext = React.createContext<WebsocketApiConnectionContextProps | null>(null);

export default function useWebsocketApiConnectionContext() {
  const context = React.useContext(WebsocketApiConnectionContext);

  if (context === null) {
    throw new Error('useWebsocketApiConnectionContext must be used within a WebsocketApiConnectionContextProvider');
  }
  return context;
}
